import React, { Component } from 'react';
import { Button, Card, Form, Input, message } from 'antd';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

import { BackBtn } from '@comm/BackBtn';
import util from '@util/index';
import FlowOp from '@comm/workflow/submitOp';
import { queryIncCustomInfo } from '@api/incubator/custom';
import { queryDeleteRefund, querySaveRefund } from '@api/incubator/refund';
import { queryOrgList } from '@api/core/org';
import ModalFileList from '../comm/ModalFileList';
import ModalIncomeList from '../comm/ModalIncomeList';
import TableFile from '../comm/TableFile';
import TableIncome from '../comm/TableIncome';
import SelectCustom from '../comm/SelectCustom';

const FormItem = Form.Item;

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileList: this.props.data ? this.props.data.files || [] : [],
      incomeList: this.props.data ? this.props.data.incomes || [] : [],
      customUuid: this.props.data ? this.props.data.customUuid : '',
      incomeVisible: false,
      customInfo: {},
    };
  }

  componentDidMount() {
    this.getOrgList();
  }

  getOrgList = () => {
    const { data, incuInfo } = this.props;
    queryOrgList({
      type: 1,
      uuid: 'F58BDBC0066B4FB0A8E54BCAF77DA727',
    }).then(res => {
      if (data && data.companyUuid) {
        this.initCompany(res.data, data.companyUuid);
      } else if (incuInfo.companyUuid) {
        this.initCompany(res.data, incuInfo.companyUuid);
      }
    });
  };

  // 初始化开票公司名称
  initCompany = (org, key) => {
    const currentCompany = org.find(item => item.uuid === key);
    this.setState({
      company: currentCompany ? currentCompany.name : '',
    });
    this.props.form.setFieldsValue({
      company: currentCompany ? currentCompany.name : '',
    });
  };

  getIncCustomInfo = () => {
    queryIncCustomInfo({
      customUuid: this.customUuid,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          customInfo: res.data,
        });
      }
    });
  };

  refundSave = params => {
    this.setState({
      submiting: true,
    });
    querySaveRefund(params).then(res => {
      this.setState({
        submiting: false,
      });
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.replace(`/incubator/refund_manage`);
      } else {
        message.error(res.message);
      }
    });
  };

  handleDelete = uuid => {
    queryDeleteRefund({ uuid }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.replace(`/incubator/refund_manage`);
      } else {
        message.error(res.message);
      }
    });
  };

  handleFileVisible = flag => {
    this.setState({
      fileVisible: !!flag,
    });
  };

  handleIncomeVisible = flag => {
    this.setState({
      incomeVisible: !!flag,
    });
  };

  handleChooseFile = params => {
    this.setState({
      fileList: params,
      showFileTips: params.length === 0,
    });
  };

  handleChooseIncome = params => {
    console.log('params:', params);
    this.setState({
      incomeList: params,
      showIncomeTips: params.length === 0,
    });
  };

  validateData = (data, tips, type) => {
    if (!data.length) {
      message.warn(`没有选择${tips}！`);
      const params = {};
      params[`show${type}Tips`] = true;
      this.setState(params);
      return false;
    }
    return true;
  };

  submit = op => e => {
    if (e) {
      e.preventDefault();
    }
    const { data } = this.props;
    const { fileList, incomeList } = this.state;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (!this.validateData(fileList, '附件', 'File')) {
          return;
        }
        if (!this.validateData(incomeList, '资金流水', 'Income')) {
          return;
        }
        if (data && data.uuid) {
          values.uuid = data.uuid;
        }
        const params = {
          ...values,
          price: incomeList.reduce((prev, curr) => prev + curr.money, 0),
          files: fileList,
          incomeUuids: incomeList.map(item => item.uuid),
        };
        if (op === 'audit') {
          this.refundSave(params);
        } else {
          message.warn('保存草稿功能正在开发，敬请期待！');
        }
      }
    });
  };

  handleCustomChange = (e, option) => {
    this.customUuid = e;
    this.setState({
      customUuid: e,
    });
    this.getIncCustomInfo();
    this.props.form.setFieldsValue({ custom: option.props.children });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const {
      fileVisible,
      showFileTips,
      showIncomeTips,
      fileList,
      incomeList,
      customUuid,
      incomeVisible,
      company,
      customInfo,
      submiting,
    } = this.state;
    const { data, incuInfo } = this.props;
    const ItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
        md: { span: 10 },
      },
    };
    getFieldDecorator('company', { initialValue: data ? data.company : '' });
    getFieldDecorator('companyUuid', {
      initialValue: data ? data.companyUuid : incuInfo.companyUuid,
    });
    getFieldDecorator('custom', { initialValue: data ? data.custom : '' });
    return (
      <Form>
        <div style={{ marginBottom: 15 }}>
          <BackBtn />
          <FlowOp handleClick={this.submit} loading={submiting} />
          {data && data.uuid ? (
            <Button
              icon="delete"
              style={{ marginRight: 10 }}
              onClick={() => this.handleDelete(data.uuid)}
            >
              删除
            </Button>
          ) : null}
        </div>
        <Card title="错款退还申请">
          <FormItem label="付款公司名称" {...ItemLayout}>
            {company}
          </FormItem>
          <FormItem label="客户名称" {...ItemLayout}>
            {getFieldDecorator('customUuid', {
              rules: [{ required: true, message: '请选择客户!' }],
              initialValue: data ? data.customUuid : '',
            })(
              <SelectCustom
                onChange={this.handleCustomChange}
                customName={data ? data.custom : ''}
              />,
            )}
          </FormItem>
          <FormItem label="资金流水" {...ItemLayout}>
            {customUuid ? (
              <a onClick={() => this.handleIncomeVisible(true)}>选择资金流水</a>
            ) : (
              <span>请先选择客户</span>
            )}
            {showIncomeTips ? (
              <span style={{ color: 'red', paddingLeft: '10px' }}>相关资金流水必选！</span>
            ) : null}
            {incomeList.length > 0 ? (
              <TableIncome dataSource={incomeList} handleChooseData={this.handleChooseIncome} />
            ) : null}
          </FormItem>
          <FormItem label="退款金额" {...ItemLayout}>
            {util.numberFormat(incomeList.reduce((prev, curr) => prev + curr.money, 0))}
          </FormItem>
          <FormItem label="公司抬头" {...ItemLayout}>
            {getFieldDecorator('accountName', {
              rules: [{ required: true, message: '请输入公司抬头!' }],
              initialValue: data ? data.accountName : '',
            })(<Input />)}
          </FormItem>
          <FormItem label="银行账号" {...ItemLayout}>
            {getFieldDecorator('account', {
              rules: [{ required: true, message: '请输入银行账号!' }],
              initialValue: data ? data.account : `${customInfo.account ? customInfo.account : ''}`,
            })(<Input />)}
          </FormItem>
          <FormItem label="开户行" {...ItemLayout}>
            {getFieldDecorator('accountBank', {
              rules: [{ required: true, message: '请输入开户行!' }],
              initialValue: data
                ? data.accountBank
                : `${customInfo.accountBank ? customInfo.accountBank : ''}`,
            })(<Input />)}
          </FormItem>
          <FormItem label="相关附件" {...ItemLayout}>
            {customUuid ? (
              <a onClick={() => this.handleFileVisible(true)}>选择附件</a>
            ) : (
              <span>请先选择客户</span>
            )}
            {showFileTips ? (
              <span style={{ color: 'red', paddingLeft: '10px' }}>附件必须上传！</span>
            ) : null}
            {fileList.length > 0 ? (
              <TableFile dataSource={fileList} handleChooseFile={this.handleChooseFile} />
            ) : null}
          </FormItem>
          <FormItem label="退款申请说明" {...ItemLayout}>
            {getFieldDecorator('reason', {
              rules: [{ required: true, message: '请输入退款申请说明!' }],
              initialValue: data ? data.reason : '',
            })(
              <Input.TextArea
                placeholder="退款申请说明"
                type="textarea"
                autosize={{ minRows: 3, maxRows: 9 }}
                maxLength={1000}
              />,
            )}
            <span style={{ fontSize: '12px', color: '#999' }}>*最多可输入1000字</span>
          </FormItem>
        </Card>
        {incomeVisible ? (
          <ModalIncomeList
            incubatorUuid={incuInfo.uuid}
            customUuid={customUuid}
            visible={incomeVisible}
            selectedRows={incomeList}
            handleCancel={this.handleIncomeVisible}
            handleChooseData={this.handleChooseIncome}
          />
        ) : null}
        {fileVisible ? (
          <ModalFileList
            customUuid={customUuid}
            fileVisible={fileVisible}
            selectedRows={fileList}
            handleCancel={this.handleFileVisible}
            handleChooseFile={this.handleChooseFile}
          />
        ) : null}
      </Form>
    );
  }
}

export default connect(state => ({
  incuInfo: state.incubator_base,
}))(Form.create({ wrappedComponentRef: true })(BaseForm));



// WEBPACK FOOTER //
// ./src/components/incubator/refund/FormBase.js